// extracted by mini-css-extract-plugin
export default {"table":"PosRates_table__2axuc","checkbox":"PosRates_checkbox__kkjye","button":"PosRates_button__YFRmh","addRateButton":"PosRates_addRateButton__-nmqZ"};